import { CONSTANTS } from '../game.js';

/**
 * 評価テキスト用のテクスチャを生成するクラス
 */
export class EvaluationTexture {
    /**
     * 全ての評価テクスチャを生成する
     * @param {Phaser.Scene} scene - テクスチャを生成するシーン
     * @returns {boolean} テクスチャ生成の成否
     */
    static createAll(scene) {
        try {
            // 各評価テクスチャを生成
            const failSuccess = this.createEvaluationTexture(scene, 'FAIL', CONSTANTS.EVALUATION.TEXT.FAIL, CONSTANTS.EVALUATION.SETTINGS.FAIL.color);
            const passSuccess = this.createEvaluationTexture(scene, 'PASS', CONSTANTS.EVALUATION.TEXT.PASS, CONSTANTS.EVALUATION.SETTINGS.PASS.color);
            const goodSuccess = this.createEvaluationTexture(scene, 'GOOD', CONSTANTS.EVALUATION.TEXT.GOOD, CONSTANTS.EVALUATION.SETTINGS.GOOD.color);
            const greatSuccess = this.createEvaluationTexture(scene, 'GREAT', CONSTANTS.EVALUATION.TEXT.GREAT, CONSTANTS.EVALUATION.SETTINGS.GREAT.color);
            const perfectSuccess = this.createEvaluationTexture(scene, 'PERFECT', CONSTANTS.EVALUATION.TEXT.PERFECT, CONSTANTS.EVALUATION.SETTINGS.PERFECT.color);
            
            // 全てのテクスチャが正常に生成されたかチェック
            const allSuccess = failSuccess && passSuccess && goodSuccess && greatSuccess && perfectSuccess;
            
            if (allSuccess) {
                console.log('EvaluationTexture: 全ての評価テクスチャを生成しました');
            } else {
                console.error('EvaluationTexture: 一部の評価テクスチャの生成に失敗しました');
            }
            
            return allSuccess;
        } catch (error) {
            console.error('EvaluationTexture: 評価テクスチャの生成中にエラーが発生しました', error);
            return false;
        }
    }
    
    /**
     * 評価テクスチャを生成する
     * @param {Phaser.Scene} scene - テクスチャを生成するシーン
     * @param {string} key - 評価キー（'FAIL', 'PASS', 'GOOD', 'GREAT', 'PERFECT'）
     * @param {string} text - 表示テキスト（'不可', '可', '優良', '秀逸', '完璧'）
     * @param {string} color - テキストの色（16進数カラーコード）
     * @returns {boolean} テクスチャ生成の成否
     */
    static createEvaluationTexture(scene, key, text, color) {
        // CONSTANTS.EVALUATION.TEXTURE_KEYSから対応するテクスチャ名を取得
        const textureName = CONSTANTS.EVALUATION.TEXTURE_KEYS[key];
        
        try {
            // 既にテクスチャが存在する場合は作成しない
            if (scene.textures.exists(textureName)) {
                console.log(`EvaluationTexture: ${textureName}テクスチャは既に存在します`);
                return true;
            }
            
            // テキストを描画するためのグラフィックスオブジェクトを作成
            const graphics = scene.add.graphics();
            
            // テキストオブジェクトを作成（一時的に使用）
            const tempText = scene.add.text(0, 0, text, {
                fontFamily: 'DotGothic16',
                fontSize: '64px',
                fill: color,
                stroke: '#000000',
                strokeThickness: 5
            });
            
            // テキストの幅と高さを取得
            const width = tempText.width + 20; // 余白を追加
            const height = tempText.height + 20; // 余白を追加
            
            // テキストを中央に配置
            tempText.setPosition(width / 2 - tempText.width / 2, height / 2 - tempText.height / 2);
            
            // テキストをレンダーテクスチャに描画
            const rt = scene.add.renderTexture(0, 0, width, height);
            rt.draw(tempText);
            
            // レンダーテクスチャからテクスチャを生成
            rt.saveTexture(textureName);
            
            // 一時オブジェクトを破棄
            tempText.destroy();
            rt.destroy();
            
            console.log(`EvaluationTexture: ${textureName}テクスチャを生成しました`);
            return true;
        } catch (error) {
            console.error(`EvaluationTexture: ${textureName}テクスチャの生成中にエラーが発生しました`, error);
            return false;
        }
    }
}
